import { IAppuntamento } from 'app/model/appuntamento';
import { IConflict } from 'app/model/appuntamenti';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';

type FieldSolution = 0|1;

interface IConflictSolution {
	title?: FieldSolution;
	indirizzo?: FieldSolution;
	numciv?: FieldSolution;
	citta?: FieldSolution;
	CAP?: FieldSolution;
	provincia?: FieldSolution;
	descrizione?: FieldSolution;
	categoria?: FieldSolution;
	evento?: FieldSolution;
	start?: FieldSolution;
	end?: FieldSolution;
}

@Component({
	selector: 'app-conflict',
	templateUrl: './conflict.html',
	styleUrls: ['./conflict.css']
})

export class ConflictComponent {

	set conflict(value: IConflict<IAppuntamento>) {
		this.conflicting = [ value.value, value.most_recent ];
		this.conflictSolution = { };

		if(!!value.value && !!value.most_recent) { 
			for(let field of ConflictComponent.fields) {
				if(this.areEqual(value.value[field], value.most_recent[field])) {
					this.conflictSolution[field] = 0;
				}
			}
		} else {
			const who = isNullOrUndefined(value.value) ? 1 : 0;
			this.conflictSolution = ConflictComponent.fields.reduce((out, field) => {
				out[field] = who;
				return out;
			}, {});
		}
	}
	
	public conflicting: IAppuntamento[] = [];
	public conflictSolution:  IConflictSolution;

	private static readonly fields = [
		'categoria',
		'evento',
		'title',
		'start',
		'end',
		'indirizzo',
		'numciv',
		'citta',
		'CAP',
		'provincia',
		'descrizione'
	];
	
	get nuovo() : IAppuntamento {
		return {
			id: this.conflicting.find(c => !!c).id,
			version: Math.max(...this.conflicting.map(c => c ? c.version : -1)) + 1,
			last_update: moment.utc(),
			status: 'U',

			categoria: this.conflicting[this.conflictSolution.categoria!].categoria,
			evento: this.conflicting[this.conflictSolution.evento!].evento,
			title: this.conflicting[this.conflictSolution.title!].title,
			start: this.conflicting[this.conflictSolution.start!].start,
			end: this.conflicting[this.conflictSolution.end!].end,
			indirizzo: this.conflicting[this.conflictSolution.indirizzo!].indirizzo,
			numciv: this.conflicting[this.conflictSolution.numciv!].numciv,
			citta: this.conflicting[this.conflictSolution.citta!].citta,
			CAP: this.conflicting[this.conflictSolution.CAP!].CAP,
			provincia: this.conflicting[this.conflictSolution.provincia!].provincia,
			descrizione: this.conflicting[this.conflictSolution.descrizione!].descrizione
		}
	};

	constructor(public activeModal: NgbActiveModal) { }

	select(property: string, index: FieldSolution) {
		this.conflictSolution[property] = index;
	}

	colorNuovo(key: string) {
		if (this.areEqual(this.conflicting[0][key], this.conflicting[1][key])) {
			return 'lightgray';
		} else {
			return 'black';
		}
	}

	areEqual(a: any, b: any): boolean {
		// Questo serve per rendere gestire bene l'assenza di uno dei due elementi
		if(!this.conflicting[0] || !this.conflicting[1]) {
			return true;
		}

		// Gestione di momentjs
		if(moment.isMoment(a)) {
			return a.isSame(b);
		}
		return a == b;
	}

	isNullOrUndefined = isNullOrUndefined;

	color(key: string, index: FieldSolution) {
		if (this.conflictSolution[key] === index) {
			return 'green';
		} else {
			return 'gray';
		}
	}

	valid() {
		if(!this.conflictSolution) {
			return false;
		} else {
			for(let field of ConflictComponent.fields) {
				if(!(field in this.conflictSolution)) {
					return false;
				}
			}

			const start = this.conflicting[this.conflictSolution.start!].start!,
				end = this.conflicting[this.conflictSolution.end!].end;

			return !(end && start.isAfter(end));
		}
	}
}
 


// WEBPACK FOOTER //
// ./src/app/calendar/conflict/conflict.ts